import React from 'react'

// Arrow navigation icon (from arrow_forward.svg)
export function ArrowIcon({ className = '', ...props }) {
  return (
    <svg 
      width="20" 
      height="20" 
      viewBox="0 0 20 20" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path 
        d="M10.0002 3.3335L8.82516 4.5085L13.4752 9.16683H3.3335V10.8335H13.4752L8.82516 15.4918L10.0002 16.6668L16.6668 10.0002L10.0002 3.3335Z" 
        fill="currentColor"
      />
    </svg>
  )
}

// Play icon for video thumbnails
export function PlayIcon({ className = '', ...props }) {
  return (
    <svg 
      width="50" 
      height="50" 
      viewBox="0 0 50 50" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <circle cx="25" cy="25" r="24" fill="rgba(0,0,0,0.6)" stroke="white" strokeWidth="1"/>
      <path d="M20 15 L35 25 L20 35 Z" fill="white"/>
    </svg>
  )
}

